import JsonViewer from 'vue-json-viewer'

export default {
  name: 'message-queue-details-dialog',
  components: {
    JsonViewer
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    message: {
      type: Object,
      default: null
    }
  },
  computed: {
    dialogModel: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    metadataValue () {
      const metadata = this.message && this.message.metadata
      if (metadata && typeof metadata === 'object') {
        return metadata
      }
      return {}
    },
    hasMetadata () {
      const metadata = this.metadataValue
      return !!(metadata && Object.keys(metadata).length)
    },
    deliveryReports () {
      const reports = this.message && this.message.deliveryReportRows
      return reports && reports.length ? reports : []
    },
    errorEntries () {
      const errors = this.message && this.message.error
      return Array.isArray(errors) ? errors : []
    }
  },
  methods: {
    closeDialog () {
      this.dialogModel = false
    }
  }
}
